// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10ucO","colMin":"styles_colMin__kC6ex"};